import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CamJobModel} from "../../../api/entity/camJob.model";
import {CamJobConverter} from "../../../api/entity/converter/camJob.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";


@Injectable({
    providedIn: 'root'
})
export class CamJobDataService extends AbstractDataServiceV2<CamJobModel, CamJobConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: CamJobConverter) {
        super('CamJob', http, httpUrlGenerator, logger, config, converter);
    }
}
